import { render, staticRenderFns } from "./objednavka-kosik.vue?vue&type=template&id=2d6931c2&scoped=true"
import script from "./objednavka-kosik.vue?vue&type=script&lang=js"
export * from "./objednavka-kosik.vue?vue&type=script&lang=js"
import style0 from "./objednavka-kosik.vue?vue&type=style&index=0&id=2d6931c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6931c2",
  null
  
)

export default component.exports